export const TEAMLIST_SEARCH = 'TEAMLIST_SEARCH';
export const TEAMLIST_PAGE = 'TEAMLIST_PAGE';
